<template>
	<page>
		<module>
			<view-list ref="view" :work-type="workType" selector :view-config="auth('b_sysuser_viewmanage')">
				<template #search>
					<m-search ref="search" :default-data="defaultSearchData">
						<m-search-item label="账号">
							<c-input name="user_name"></c-input>
						</m-search-item>
						<m-search-item label="姓名">
							<c-input name="user_realname"></c-input>
						</m-search-item>
						<m-search-item label="手机号码">
							<c-input name="phone"></c-input>
						</m-search-item>
						<m-search-item label="角色">
							<c-select name="role_id" async @search="searchRole"></c-select>
						</m-search-item>
						<m-search-item label="部门">
                            <c-select name="department_ids" async @search="searchDepartment" multiple></c-select>
						</m-search-item>
                        <m-search-item label="网点">
                            <c-select name="outlet_id" async @search="searchOutlet" multiple></c-select>
                        </m-search-item>
                        <m-search-item label="职级">
                            <c-select name="position_level_ids" async @search="searchPositionLevel" multiple></c-select>
						</m-search-item>
<!--						<m-search-item>-->
<!--							<c-checkbox-group name="user_types" :options="userTypeDic"></c-checkbox-group>-->
<!--						</m-search-item>-->
						<m-search-item>
							<c-checkbox-group name="state" :options="disableEnableDic"></c-checkbox-group>
						</m-search-item>
                        <m-search-item label="接单状态">
							<c-checkbox-group name="receive_status" :options="receiveStatusDic"></c-checkbox-group>
						</m-search-item>
                        <m-search-item label="临时支援">
							<c-checkbox-group name="temp_support_enabled" :options="tempSupportStatusDic"></c-checkbox-group>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button color="main" v-if="auth('b_sysuser_edit')" prepend-icon="tf-add" @click="$refs.sysuserEdit.open()">创建用户</c-button>
<!--                    <c-button v-if="auth('b_sysuser_edit')" prepend-icon="tf-import" @click="$refs.view.excelImport()">导入数据</c-button>-->
				</template>
				
				<template #batchOperate="{data}">
                    <c-button v-if="auth('b_sysuser_auth')" prepend-icon="tf-auth" @click="batchEditUserRole()">复制角色权限</c-button>
                    <c-button v-if="auth('b_sysuser_edit')" prepend-icon="tf-edit" @click="batchSetStarLevel()">批量设置星级</c-button>
<!--                    <c-button v-if="auth('b_sysuser_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">按视图导出</c-button>-->
<!--					<c-button v-if="auth('b_sysuser_print')"  prepend-icon="tf-print" @click="$refs.view.batchExportByTemplate()">批量打印</c-button>-->
				</template>

				<template #otherOperate>
<!--					<c-button v-if="auth('b_sysuser_log')" prepend-icon="tf-import-record" @click="$refs.view.loadImportLogDetail()">导入记录</c-button>-->
					<c-button v-if="auth('b_sysuser_log')" prepend-icon="tf-operate-record" @click="$refs.view.loadWorkLogDetail()">操作记录</c-button>
				</template>
				
				<!--启禁用状态-->
				<template #state="{data}">
					<c-switch v-if="auth('b_sysuser_edit') && data.is_manage != 1 " v-model="data.state" :state-value="[1, 2]" :state-text="['启用','禁用']" @beforeChange="stateHandle(arguments[0], arguments[1], data)"></c-switch>
					<c-state v-else dict="disableEnableDic" :value="data.state"></c-state>
				</template>
				
				<!--计价方式-->
				<template #pricing_type="{data}">
					<c-state dict="pricingTypeDic" :value="data.pricing_type"></c-state>
				</template>

				<!--账号类型-->
				<template #user_type="{data}">
					<c-state dict="userTypeDic" :value="data.user_type"></c-state>
				</template>

                <!--接单状态-->
                <template #receive_status="{data}">
                    <span v-if="(data.position_name == '售后工程师'||data.position_name == '售后服务工程师')  && data.receive_status == 1">
                        <c-state dict="receiveStatusDic" :value="data.receive_status"></c-state>
                    </span>
                    <span v-else-if="(data.position_name == '售后工程师'||data.position_name == '售后服务工程师')  && data.receive_status == 2">
                        <c-tooltip  tip="提示信息">
                            <c-state dict="receiveStatusDic" tag :value="data.receive_status"></c-state>
                            <template #tip>
                                <p>暂停接单时间：{{data.pause_start_time}} - {{data.pause_end_time}}</p>
                            </template>
                        </c-tooltip>
                    </span>
                    <span v-else>-</span>
                </template>

				<!--锁定状态-->
				<template #is_lock="{data}">
					<c-state v-if="data.user_type == 1" dict="lockStateDic" :value="data.is_lock"></c-state>
					<span v-else>-</span>
				</template>

                <!--星级-->
                <template #star_level="{data}">
                    <c-state dict="starLevelDic" :value="data.star_level"></c-state>
                </template>

                <!--临时支援-->
                <template #is_temp_support_enabled="{data}">
                    <span v-if="(data.position_name == '售后工程师'||data.position_name == '售后服务工程师')  && data.is_temp_support_enabled == 2">
                        <c-state dict="tempSupportStatusDic" :value="data.is_temp_support_enabled"></c-state>
                    </span>
                    <span v-else-if="(data.position_name == '售后工程师'||data.position_name == '售后服务工程师')  && data.is_temp_support_enabled == 1">
                        <c-tooltip  tip="提示信息">
                            <c-state dict="tempSupportStatusDic" tag :value="data.is_temp_support_enabled"></c-state>
                            <template #tip>
                                <p>支援网点：{{data.support_outlet_name}}</p>
                                <p>支援时间：{{data.support_start_time}} - {{data.support_end_time}}</p>
                                <p>支援说明：{{data.support_desc||'-'}}</p>
                            </template>
                        </c-tooltip>
                    </span>
                    <span v-else>-</span>
                </template>

				<!--部门 -->
				<template #department_names="{data}">
					<span v-if="!data.department_name" >-</span>
					<c-tags v-else :value="data.department_name"></c-tags>
				</template>
				
				<!--角色 -->
				<template #role_names="{data}">
					<template v-if="data.user_type == 1">
						<span v-if="!data.role_names" >-</span>
						<span v-else-if="data.auth_type==2" style="color:#999">{{data.role_names}}</span>
						<span v-else>{{data.role_names}}</span>
					</template>
					<template v-else>
						-
					</template>
				</template>

                <!--头像-->
                <template #head_photo="{data}">
                    <c-file v-if="data.head_photo" class="img" :src="data.head_photo" media style="width:30px;height:30px;"></c-file>
                </template>
				<!--锁定状-->
				<template #is_lock_tip="{data}">
					<c-tooltip tip="提示" width="300">
						<template #tip>
							<p>锁定状态说明：</p>
							<p>锁定：登陆账户密码错误次数过多，账户将自动锁定，锁定后将无法使用账号密码方式登陆</p>
							<p>风险解除：风险解除后可正常使用账号密码方式登陆</p>
						</template>
					</c-tooltip>
				</template>

				<c-table-column
					type="button"
					label="操作"
					width="250"
					button-limit="4"
				>
					<template #default="{data}">
						<!-- <c-table-button v-if="auth('b_sysuser_edit')" icon="tf-reset-password" @click="removeSysuser(data)">删除</c-table-button> -->
						<c-table-button v-if="auth('b_sysuser_edit')" icon="tf-reset-password" @click="resetPwd(data)">重置密码</c-table-button>
						<c-table-button v-if="auth('b_sysuser_edit')" icon="tf-edit" @click="$refs.sysuserEdit.open(data)">编辑</c-table-button>
<!--						<c-table-button v-if="auth('b_sysuser_print')" icon="tf-print" @click="$refs.view.exportByTemplate(data.id)">打印</c-table-button>-->
						<c-table-button v-if="auth('b_sysuser_auth') && data.is_manage != 1 && data.user_type == 1" icon="tf-auth" @click="$refs.sysuserAuthConfig.open(data, 0)">PC端权限</c-table-button>
						<c-table-button v-if="auth('b_sysuser_auth') && data.is_manage != 1 && data.user_type == 1" icon="tf-auth" @click="$refs.sysuserAuthConfig.open(data, 1)">手机端权限</c-table-button>
						<c-table-button v-if="auth('b_sysuser_auth') && data.is_manage != 1 && data.user_type == 1" icon="tf-copy" @click="$refs.sysuserAuthCopy.open(data, 0)">复制权限</c-table-button>
						<c-table-button v-if="auth('b_sysuser_edit')" :disabled="data.is_lock == 0" icon="tf-lock" @click="riskRemoval(data)">账号解锁</c-table-button>
                        <c-table-button v-if="auth('b_sysuser_receive_config')" :disabled="!(data.position_name == '售后工程师'||data.position_name == '售后服务工程师')" icon="tf-order-config" @click="$refs.sysuserReceiveConfig.open(data.id)">自动接单设置</c-table-button>
					</template>
				</c-table-column>
			</view-list>
			<!--编辑用户信息弹窗-->
			<sysuser-edit ref="sysuserEdit" @resolve="$refs.view.$refs.list.update()"></sysuser-edit>
			<!--设置用户权限编辑弹窗-->
			<sysuser-auth-config ref="sysuserAuthConfig"  @resolve="$refs.view.$refs.list.update()"></sysuser-auth-config>
			<!--设置用户权限复制弹窗-->
			<sysuser-auth-copy ref="sysuserAuthCopy"></sysuser-auth-copy>
			<!--编辑用户角色弹窗-->
			<sysuser-role-edit ref="sysuserRoleEdit" @resolve="$refs.view.$refs.list.update()"></sysuser-role-edit>
            <!--设置用户自动接单弹窗-->
            <sysuser-receive-config ref="sysuserReceiveConfig" @resolve="$refs.view.$refs.list.update()"></sysuser-receive-config>
            <!--批量设置工程师星级弹窗-->
            <sysuser-batch-set-star ref="sysuserBatchSetStar" @resolve="$refs.view.$refs.list.update()"></sysuser-batch-set-star>
        </module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	import sysuserEdit from "@/pages/system/sysuser_edit.vue";
	import sysuserAuthConfig from "@/pages/system/sysuser_auth_config.vue";
	import sysuserAuthCopy from "@/pages/system/sysuser_auth_copy.vue";
	import sysuserRoleEdit from "@/pages/system/sysuser_role_edit.vue";
    import sysuserReceiveConfig from "@/pages/system/sysuser_receive_config.vue";
    import sysuserBatchSetStar from "@/pages/system/sysuser_batch_set_star.vue";
	export default {
		components: {sysuserEdit, sysuserAuthConfig, sysuserAuthCopy,sysuserRoleEdit,sysuserReceiveConfig,sysuserBatchSetStar},
		computed: {
			// 获取dictName选项数据
			...mapState(['disableEnableDic', 'userTypeDic', 'pricingTypeDic', 'receiveStatusDic', 'tempSupportStatusDic']),
		},

		data() {
			return {
                workType:27,                //系统用户
				defaultSearchData: {
					'state': [1]
				},
                user_type:1
			}
		},

		methods: {
			/*******搜索角色*****************/
			searchRole(keyword, resolve){
				this.request({
					url:'/system/native/options',
					data: {
						options_code:'ROLE'
					},
					success:data => {
						resolve(data);
					}
				})
			},
			
			/*******搜索部门*****************/
			searchDepartment(keyword, resolve){
				this.request({
					url:'/department/tree_options',
					data: {
						options_code:'DEPARTMENT',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},
            /*******搜索网点*****************/
            searchOutlet(keyword, resolve){
                this.request({
                    url:'/system/options',
                    data: {
                        options_code:'AFTERSALE_OUTLET',
                        keyword:keyword
                    },
                    success:data => {
                        resolve(data);
                    }
                })
            },
            searchPositionLevel(keyword, resolve){
                this.request({
                    url:'/system/options',
                    data: {
                        options_code:'POSITION',
                        keyword:keyword
                    },
                    success:data => {
                        resolve(data);
                    }
                })
            },
			
			/******删除用户***********/
			removeSysuser(data){
				this.$confirm({
					message:'确认删除用户【'+data.user_realname+'】？删除后不可恢复',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/sys_user/delete',
							data: {id:data.id},
							loading: true,
							success: data => {
								this.$message({
									message:'删除成功',  // 提示内容,
									type: 'success'
								});
								this.$refs.view.$refs.list.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},

			/******重置密码***********/
			resetPwd(data){
				this.$confirm({
					message:'确定重置用户【'+data.user_realname+'】的登录密码？',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/sys_user/reset_pwd',
							data: {id:data.id},
							loading: true,
							success: result => {
								this.$confirm({
									message: result,
									buttonName: '知道了',
									cancelButton: false,
									resolve: () => {
									}
								});
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},

			/******用户启禁用*********/
			stateHandle(state, next, data) {
				this.request({
					url: '/sys_user/update_state',
					data: {
						id: data.id,
						state: state ? 2 : 1
					},
					success: (data, message) => {
						this.$message({
							message: message,  // 提示内容,
							type: 'success'
						});
						next();
					}
				})
			},
			
			/******账号类型切换*********/
			userTypeHandle(user_type, next, data) {
				this.request({
					url: '/sys_user/update_user_type',
					data: {
						id: data.id,
						user_type: user_type ? 2 : 1
					},
					success: (data, message) => {
						this.$message({
							message: message,  // 提示内容,
							type: 'success'
						});
						next();
					}
				})
			},
			
			/******解锁账户***********/
			riskRemoval(item){
				this.$confirm({
					message:'解锁用户【'+item.user_realname+'】为正常状态？',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/sys_user/riskRemovalByUserId',
							data: {
								user_id: item.id
							},
							loading: true,
							success: (data, message) => {
								this.$message({
									message: message,  // 提示内容,
									type: 'success'
								});
								item.is_lock = 0;
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},

            /****批量修改用户角色****/
            batchEditUserRole(){
                var ids = [];
                var user_realnames = [];
                this.$refs.view.$refs.list.getData('selected').forEach(item => {
                    ids.push(item.id);
                    user_realnames.push(item.user_realname);
                });
                var data = {};
                data.user_ids = ids;
                data.user_realnames = user_realnames.join("；");
                this.$refs.sysuserRoleEdit.open(data);
            },
            /****批量设置工程师星级****/
            batchSetStarLevel(){
                var ids = [];
                var user_realnames = [];
                var hasNonEngineer = false;
                this.$refs.view.$refs.list.getData('selected').forEach(item => {
                    if (item.position_name !== '售后工程师' && item.position_name !== '售后服务工程师') {
                        hasNonEngineer = true;
                    }
                    ids.push(item.id);
                    user_realnames.push(item.user_realname);
                });
                if (hasNonEngineer) {
                    this.$message({
                        message: '仅限售后工程师可批量设置星级',
                        type: 'warn'
                    });
                    return;
                }
                var data = {};
                data.user_ids = ids;
                data.user_realnames = user_realnames.join("；");
                this.$refs.sysuserBatchSetStar.open(data);
            },
		}
	}
</script>

<style lang="stylus" scoped>
</style>